// src/crm/pipeline/stages.ts
import type { ContactType, DealStage } from '../../lib/types'

export const STAGES: DealStage[] = [
  'prospecte',
  'contacte',
  'en_discussion',
  'accepte',
  'brief_envoye',
  'contenu_recu',
  'publie',
  'paye_cloture',
  'decline_archive',
]

export const STAGE_LABELS: Record<DealStage, string> = {
  prospecte: 'Prospecté',
  contacte: 'Contacté',
  en_discussion: 'En discussion',
  accepte: 'Accepté',
  brief_envoye: 'Brief envoyé',
  contenu_recu: 'Contenu reçu',
  publie: 'Publié',
  paye_cloture: 'Payé / Clôturé',
  decline_archive: 'Décliné / Archivé',
}

const PRESS_LABELS: Record<DealStage, string> = {
  prospecte: 'À pitcher',
  contacte: 'Pitché',
  en_discussion: 'En échange',
  accepte: 'Intéressé',
  brief_envoye: 'Kit média envoyé',
  contenu_recu: 'Contenu reçu',
  publie: 'Couvert',
  paye_cloture: 'Clôturé',
  decline_archive: 'Décliné',
}

const PARTNER_LABELS: Record<DealStage, string> = {
  ...STAGE_LABELS,
  contenu_recu: 'Livrable reçu',
}

export const STAGE_LABELS_BY_TYPE: Record<ContactType, Record<DealStage, string>> = {
  ugc_creator: STAGE_LABELS,
  press: PRESS_LABELS,
  partner: PARTNER_LABELS,
  sponsor: PARTNER_LABELS,
}

// Colonnes masquées par type. Une colonne masquée est rendue quand même si elle
// contient au moins un deal du type filtré (spec §1.3) : aucun deal ne disparaît
// jamais du Kanban, on ne peut simplement pas y en déposer de nouveau.
export const MASKED_STAGES_BY_TYPE: Record<ContactType, DealStage[]> = {
  ugc_creator: [],
  press: ['contenu_recu'],
  partner: [],
  sponsor: [],
}
